export const IRCTCAccountCreationURL = 'https://www.irctc.co.in/eticketing/userSignUp.jsf';
export const IRCTC_CREATE_ACCOUNT_URL_BtoC = 'https://www.irctc.co.in/nget/profile/user-registration';

export const RAIL_LEGACY_LISTING_PATH = '/listing';
export const RAIL_SEO_LISTING_PATH = '/railways/railListing';
export const RAIL_LISTING_PATH = '/railways/listing';
export const RAIL_MWEB_LISTING_PATH='/railways/search/railsListingPage';
export const RAIL_REVIEW_PATH = '/railways/search/railsTravelerPage';
export const RAIL_THANK_YOU_PATH = '/railways/thankYou';
export const RAIL_LEGACY_THANK_YOU_PATH = '/thankYou';
export const RAIL_CAPTCHA_PATH = '/railways/irctcCaptchaPage';
export const RAIL_LEGACY_CAPTCHA_PATH = '/irctcCaptchaPage';
export const RAIL_RETRIEVE_PWD_PATH = '/railways/retrievePassword';
export const RAIL_LEGACY_RETRIEVE_PWD_PATH = '/railways/retrievePassword';
export const RAIL_PAYMENT_TIMEOUT_PATH = '/railways/paymentTimeOut';
export const RAIL_LEGACY_PAYMENT_TIMEOUT_PATH = '/paymentTimeOut';
export const RAIL_CREATE_NEW_ACCOUNT_PATH = '/railways/createNewAccount';
export const RAIL_TRAVELER_DETAILS_PATH = '/railways/TravellersDetails';
export const RAIL_NEED_HELP_PATH = '/railways/needHelp';
export const GROUNDS_AUTOSUGGEST_URL = "https://ground-auto-suggest.makemytrip.com/rails/autosuggest/stations?version=v1";
export const NEW_HOLIDAY_PAGE_LINK = "https://www.makemytrip.com/promos/ayodhya-packages-231023.html?cmp=Holidays_Ayodhya";
export const MMT_FAVICON = "https://www.makemytrip.com/favicon.ico?d=15";
export const FONTS = "https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900";
